@if (!linkmode) {
<div>
  @switch (template) { @case ('internal') { 
  @if (target === '_blank') {
  <a
    [href]="getFullInternalUrl()"
    target="_blank"
    rel="noopener noreferrer"
    [class.-link-active]="isLinkActive(url)"
    (click)="handleClick()">
    <ng-container *ngTemplateOutlet="content"></ng-container>
    @if (showchevron) {
    <lucide-icon name="chevron-right" class="chevron-icon"></lucide-icon>
    }
  </a>
  } @if (redirectViaServer && target !== '_blank') {
  <a [href]="getFullInternalUrl()" [target]="target || '_self'" [class.-link-active]="isLinkActive(url)" (click)="handleRedirect($event, getFullInternalUrl())">
    <ng-container *ngTemplateOutlet="content"></ng-container>
    @if (showchevron) {
    <lucide-icon name="chevron-right" class="chevron-icon"></lucide-icon>
    }
  </a>
  } @if (!redirectViaServer && target !== '_blank') {
  <a
    [routerLink]="url"
    [class.-link-active]="isLinkActive(url)"
    [queryParams]="tree.queryParams"
    [fragment]="tree.fragment"
    (click)="handleClick()">
    <ng-container *ngTemplateOutlet="content"></ng-container>
    @if (showchevron) {
    <lucide-icon name="chevron-right" class="chevron-icon"></lucide-icon>
    }
  </a>
  } } @case ('external') {
  <a [href]="to" target="_blank" rel="noopener noreferrer">
    <ng-container *ngTemplateOutlet="content"></ng-container>
    <icon icon="external-link" class="-xsm"></icon>
  </a>
  } @case ('noRoute') {
  <button type="button">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </button>
  } @case ('newTab') {
  <a [href]="to" target="_blank" rel="noopener noreferrer">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
  } }
</div>
} @if (linkmode && linkmode === 'apispec') {
<a [class]="display" [href]="to">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</a>
} @if (linkmode && linkmode === 'preNavigate') {
<a [class]="display" [href]="to" (click)="onPreNavigateClick($event)">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</a>
} @if (linkmode && linkmode === 'wp-anchor') {
<wp-anchor-link
  [attr.link-name]="linkName"
  [attr.link-url]="to"
  [attr.size]="size"
  [attr.variant]="variant"
  [attr.color]="color"
  [attr.weight]="weight"
  [attr.disabled]="disabled ? true : null"
  (click)="onWpAnchorClick($event)">
</wp-anchor-link>
}

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
